import { useState } from "react";
import { getEntity } from "services";

const useGetEntity = (entity) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const doRequest = async () => {
    setIsLoading(true);

    const response = await getEntity(entity);

    setData(response);

    setIsLoading(false);
  };

  return { data, doRequest, isLoading };
};

export { useGetEntity };
